import * as base from "../external/query-string/base.js";
const parseQs = (queryObject) => {
  if (!queryObject) return "";
  const query = {};
  Object.entries(queryObject).forEach(([key, val], index) => {
    if (key === "count") return;
    if (typeof val === "number") query[key] = val.toString();
    query[key] = val;
  });
  return "?" + base.stringify(query);
};
export {
  parseQs
};
